/* global require */

import WebComponent from 'webcomponent';

import {registerMPElement} from '../../util/register-element';
import {mapKeys} from '../../util';
import {importAll} from '../../util/webpack';

// NOTE: This component depends on styles that aren't packaged with it
// as there's no reliable, efficient way to do so.
// Option 1: Inject the CSS into the <head> tag
//   Problem: Styles don't get applied to svg-icons that happen to be in
//   ShadowDOM (like inside an mp-button component)
// Option 2: Use ShadowDOM for this component
//   Problem: This makes it a poor experience for styling the icons
//   from the "outside" which we'll often want to do for colors and
//   positioning.
// Option 3: Expect the styles to be handled separately. This is choice
//   we've made here. They come "for free" when you include "default" styles for mixpanel-common
//   which should happen for pretty much every page and every component.

const iconMap = importAll(require.context(`../../assets/icons/`, false, /\.svg$/));
const SVG_ICONS = mapKeys(iconMap, (k) => k.match(/\/(.+)\.svg$/)[1]); // strip filename cruft

export default registerMPElement(
  `svg-icon`,
  class extends WebComponent {
    static get observedAttributes() {
      return [`empty`, `icon`, `color`];
    }

    connectedCallback() {
      this.render();
    }

    attributeChangedCallback() {
      this.render();
    }

    render() {
      const icon = this.getAttribute(`icon`);
      const empty = this.isAttributeEnabled(`empty`);

      if (empty || !icon) {
        this.innerHTML = ``;
      } else {
        if (icon) {
          const markup = SVG_ICONS[icon];
          if (!markup) {
            throw new Error(`No svg-icon "${icon}" found.`);
          }
          this.innerHTML = markup;

          const color = this.getAttribute(`color`);
          if (color) {
            this.querySelector(`svg`).style.color = color;
          }
        }
      }
    }
  },
);

export {SVG_ICONS};
